import { GraphQL } from '@guestgoodie/graphql'

import { useIsFeatureConnected } from '@/features/integrations'
import { Permission, useCheckPermission } from '@/features/auth'

export function useShowDoorSelector() {
  const hasDoorSystem =
    useIsFeatureConnected(GraphQL.IntegrationTypes.DoorSystem) ?? false

  const hasDoorReadPermission = useCheckPermission([
    Permission.INTEGRATION_DOOR_READ
  ])

  return hasDoorSystem && hasDoorReadPermission
}
